import { Pipe, PipeTransform } from '@angular/core';
import { RarityType } from '../enums/rarity.type';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'rarityName',
  standalone: true,
})
export class RarityNamePipe implements PipeTransform {

  constructor() {

  }

  transform(value: RarityType): string {
    switch (value) {
      case RarityType.Unknown:
        return 'filter_creature.rarity.unknown';
      case RarityType.Common:
        return 'filter_creature.rarity.common';
      case RarityType.Rare:
        return 'filter_creature.rarity.rare';
      case RarityType.Legendary:
        return 'filter_creature.rarity.legendary';
      default:
        return 'filter_creature.rarity.invalid';
    }
  }
}